import membershipCardImg from "assets/products/mlta/membership-card-number.svg";

const WhereAAAMemberNumberModal = () => {
    const handleOpenModal = () => {
        const modal = document.getElementById("where-aaa-member-number-modal") as HTMLDialogElement;
        if (modal) {
            modal.showModal();
        }
    };

    const handleCloseModal = () => {
        const modal = document.getElementById("where-aaa-member-number-modal") as HTMLDialogElement;
        if (modal) {
            modal.close();
        }
    };

    return (
        <>
            <p
                className="pt-1 text-sm leading-5 font-bold text-question-mark cursor-pointer hover:underline"
                onClick={handleOpenModal}
                data-testid="where-aaa-member-number-modal-button"
            >
                Where to find my member number?
            </p>

            <dialog id="where-aaa-member-number-modal" className="modal" data-testid="where-aaa-member-number-modal">
                <div className="modal-box p-0">
                    <button
                        type="button"
                        autoFocus={false}
                        className="btn btn-sm text-secondary btn-ghost absolute right-3 top-3 z-10"
                        onClick={handleCloseModal}
                    >
                        ✕
                    </button>

                    <div className="w-full h-[312px] bg-gray-100 flex items-center justify-center">
                        <img
                            src={membershipCardImg}
                            alt="AAA Membership card showing member number location"
                            className="w-1/2 h-auto"
                        />
                    </div>

                    <div className="w-full h-[88px] flex items-center p-6">
                        <p className="font-medium text-base leading-6 text-black">
                            You can find your 16-digit member number on the front of your AAA Membership card, or in the AAA
                            mobile app.
                        </p>
                    </div>
                </div>
                <form method="dialog" className="modal-backdrop">
                    <button type="submit">close</button>
                </form>
            </dialog>
        </>
    );
};

export default WhereAAAMemberNumberModal;
